import {
  getFilterStore,
  LabeledFilter,
} from "../../../../../../components/dataGridFilter/createFilterStore";

export const getInventoryFilterStore = (
  storeProductStatus?: string,
  marketplaceProductStatus?: string,
  amazonListingItemStatus?: string,
) => {
  const filterStoreKey = `${storeProductStatus}-${marketplaceProductStatus}-${amazonListingItemStatus}`;

  const initialFilters: Record<string, LabeledFilter> = {};

  if (storeProductStatus) {
    initialFilters.storeProductStatus = {
      field: "storeProductStatus",
      operator: "eq",
      value: storeProductStatus,
    };
  }

  if (marketplaceProductStatus) {
    initialFilters["marketplaceProduct.marketplaceProductStatus"] = {
      field: "marketplaceProduct.marketplaceProductStatus",
      operator: "eq",
      value: marketplaceProductStatus,
    };
  }

  if (amazonListingItemStatus) {
    initialFilters.amazonListingItemStatus = {
      field: "amazonListingsItemStatus",
      operator: "eq",
      value: amazonListingItemStatus,
    };
  }

  return getFilterStore(initialFilters, "inventory", filterStoreKey);
};
